module.exports = __webpack_public_path__ + "static/media/venus-mars.ce833fa9.svg";